import { Tooltip } from 'antd';

export const irrigationStatus = {
  IRRIGATING: 'IRRIGATING',
  NOT_SCHEDULED: 'NOT_SCHEDULED',
  SCHEDULED: 'SCHEDULED',
};

export const valveOverrideState = {
  CLOSED: 'closed',
  OPEN: 'open',
  SCHEDULED: 'scheduled',
};

export const pumpOverrideState = {
  CLOSED: 'off',
  OPEN: 'on',
  SCHEDULED: 'scheduled',
};

export const installState = {
  INSTALLED: 'installed',
};

export const capabilities = {
  water_pressure: ['water_pressure'],
  aquacheck_soil: ['soil_moisture_8', 'soil_moisture_16', 'soil_moisture_24', 'soil_moisture_32', 'soil_moisture_40', 'soil_moisture_48'],
  pixl_soil: ['soil_moisture_6', 'soil_moisture_12', 'soil_moisture_18', 'soil_moisture_24', 'soil_moisture_30', 'soil_moisture_36', 'soil_moisture_42', 'soil_moisture_48'],
};

export const ALL_SENSORS_LIST = {
  weather_station: {},
  aquacheck_soil: {},
  pixl_soil: {},
  farmx_dendrometer: {},
  farmx_infrared: {},
  water_pressure: {},
  vfd: {},
  water_flow_analog: {},
  water_flow: {},
  valve: {},
  farmx_frost: {},
  gateway: {},
  sentek_soil: {},
  cavalier: {},
  temperature_humidity: {},
};

export const SENSORS_VISIBLE_TO_CLIENT = {
  weather_station: {},
  aquacheck_soil: {},
  pixl_soil: {},
  farmx_dendrometer: {},
  farmx_infrared: {},
  water_pressure: {},
  vfd: {},
  water_flow_analog: {},
  water_flow: {},
  valve: {},
  farmx_frost: {},
  temperature_humidity: {},
};

/**
 * Special Case: For GEC Project.
 * When to remove/Refactor: Once we start implementing
 * Sensor co-ordination configuration through frontend.
 */
export const GEC_RANCH_ID = Number(process.env.REACT_APP_GEC_RANCH);
export const SPRINKLER_BLOCK_ID = Number(process.env.REACT_APP_SPRINKLER_BLOCK);
export const GEC_ENTITY_ID = Number(process.env.REACT_APP_GEC_ENTITY_ID);
export const GEC_TEST_ENTITY_ID = Number(process.env?.REACT_APP_GEC_TEST_ENTITY_ID);
export const GEC_RANCH_WATERMELON_REPL = Number(process.env.REACT_APP_GEC_RANCH_WATERMELON_REPL);
export const GEC_TEST_RANCH_WATERMELON_REPL = Number(process.env?.REACT_APP_GEC_TEST_RANCH_WATERMELON_REPL);
export const GEC_RANCH_WATERMELON_AUTO = Number(process.env.REACT_APP_GEC_RANCH_WATERMELON_AUTO);
export const GEC_RANCH_SP = Number(process.env.REACT_APP_GEC_RANCH);
export const SPRINKLER_BLOCK_IDS_REPL = process.env.REACT_APP_SPRINKLER_BLOCK_IDS_REPL?.split(',')
  .map((v) => Number(v));
export const SPRINKLER_BLOCK_IDS_AUTO = process.env.REACT_APP_SPRINKLER_BLOCK_IDS_AUTO?.split(',')
  .map((v) => Number(v));
export const DRIP_COOLING_BLOCK_ID = Number(process.env.REACT_APP_DRIP_COOLING_BLOCK);
export const DRIP_COOLING_BLOCK_IDS = process.env.REACT_APP_DRIP_COOLING_BLOCKS?.split(',')
  .map((v) => Number(v));

export const SOURCE_RANCH_IDS = process.env?.REACT_APP_SOURCE_RANCHES?.split(',')
  .map((v) => Number(v));
export const GEC_RANCH_SWEETPOTATO_REPL = Number(process.env.REACT_APP_GEC_RANCH_SWEETPOTATO_REPL);
export const GEC_RANCH_SWEETPOTATO_SOURCE= Number(process.env
  ?.REACT_APP_GEC_RANCH_SWEETPOTATO_SOURCE);
export const GEC_RANCH_SWEETPOTATO_REPL_BLOCKS = process.env
  ?.REACT_APP_GEC_RANCH_SWEETPOTATO_REPL_BLOCKS?.split(',').map((v) => Number(v));
export const GEC_AUTONOMOUS_RANCHES = process.env?.REACT_APP_AUTONOMOUS_RANCHES?
  process.env.REACT_APP_AUTONOMOUS_RANCHES?.split(',').map((v) => Number(v))
  :[];

export const RECOMMENDATION_OPTIONS = [
  { label: 'Auto', value: true },
  { label: 'Let me decide', value: false },
];

export const IRRIGATION_RECOMMENDATION_STATES = {
  VERY_DRY: 'very_dry',
  DRY: 'dry',
  DRYING: 'drying',
  WELL_IRRIGATED: 'well_irrigated',
  OVER_IRRIGATED: 'over_irrigated',
};

export const IRRIGATION_RECOMMENDATION_RISK_STATES = [
  IRRIGATION_RECOMMENDATION_STATES.DRY,
  IRRIGATION_RECOMMENDATION_STATES.DRYING,
  IRRIGATION_RECOMMENDATION_STATES.VERY_DRY,
];

export const IRRIGATION_RECOMMENDATION_FORECAST_RISK_STATES = [
  IRRIGATION_RECOMMENDATION_STATES.DRY,
  IRRIGATION_RECOMMENDATION_STATES.VERY_DRY,
];

export const RECOMMENDATION_PRIORITY_LEVELS = {
  URGENT: 'urgent',
  HIGH: 'high',
  MONITOR: 'monitor',
  REDUCE: 'reduce',
  STABLE: 'stable',
};

export const STATUS_TAG_STATES = {
  GOOD: 'good',
  OVER: 'over',
};

export const STATUS_TAG_OVER_COLOR = '#2196f3';

export const STATUS_TAG_LIGHT_TEXT_STATES = [
  STATUS_TAG_STATES.GOOD,
  STATUS_TAG_STATES.OVER,
];

export const REST_AUTO_OPTIONS = [
  { label: 'Enable', value: true },
  { label: 'Disable', value: false },
];

// Summary bar graph colors as same as mockup
export const SUMMARY_GRAPH_BAR_COLOR = {
  deficit: '#f0b138',
  forecast: '#d63a29',
  totalDeficit: '#d13b3e',
  scheduled: '#4788d8',
  requiredHours: '#68c379',
  precipitationForecast: 'lightblue'
};

// Below rules only for the Form items
export const FORM_RULES = (t) => {
  return {
    requiredField: [{ required: true, message: <Tooltip title={t('This field is required.')}>
      {t('This field is required.')}
    </Tooltip>}],
    requiredBlockField: [{ required: true,  message: <Tooltip title={t('Block is required!')}>
      {t('Block is required!')}
    </Tooltip>}],
    requiredSensorField: [{ required: true, message: <Tooltip
     title={t('Reference Soil Moisture Sensor is required!')}
    >
      {t('Reference Soil Moisture Sensor is required!')}
    </Tooltip>}],
    requiredRefillDepthField: [{ required: true, message: <Tooltip title={t('Refill Depth is required!.')}>
      {t('Refill Depth is required!.')}
    </Tooltip>}],
    requiredStoppingField: [{ required: true, message: <Tooltip title={t('Stopping Depth is required!')}>
      {t('Stopping Depth is required!')}
    </Tooltip>}],
    requiredDepthField: [{ required: true, message: <Tooltip title={t('Depth is required!')}>
      {t('Depth is required!')}
    </Tooltip>}],

    requiredEndDateValidation: [
      { required: true, message: <Tooltip title={t('Please select an end date!')}>
        {t('Please select an end date!')}
      </Tooltip>},
      ({ getFieldValue }) => ({
        validator(_, value) {
        // Update the depending field value below if needed
          const startDate = getFieldValue('starting_time_window');
          if (!value || !startDate || value?.isAfter(startDate)) {
            return Promise.resolve();
          }
          return Promise.reject(
            new Error(t('End date must be after the start date!'))
          );
        },
      }),
    ],
    requiredFieldWithPercentage: [
      {
        validator(_, value) {
          if (value === undefined || value === '') {
            return Promise.reject(new Error(t('Please enter a percentage!')));
          }

          const num = Number(value);

          // Check if value is a valid number
          if (!/^\d*\.?\d+$/.test(value)) {
            return Promise.reject(new Error(t('Please enter a positive number.')));
          }

          // Check range
          if (num < 0 || num > 100) {
            return Promise.reject(new Error(t('Value must be between 0 and 100.')));
          }

          return Promise.resolve();
        },
      },
    ],
    requiredNumberField: [
      {
        required: true,
        message: <Tooltip title={t('This field is required.')}>
          {t('This field is required.')}
        </Tooltip>,
      },
      {
        pattern: /^-?\d*(\.\d+)?$/,
        message: <Tooltip title={t('Please enter a valid number.')}>
          {t('Please enter a valid number.')}
        </Tooltip>,
      },
    ],
    requiredPositiveNumberField: [
      {
        required: true,
        message: <Tooltip title={t('This field is required.')}>
          {t('This field is required.')}
        </Tooltip>,
      },
      {
        pattern: /^\d*\.?\d+$/,
        message: <Tooltip title={t('Please enter a positive number.')}>
          {t('Please enter a positive number.')}
        </Tooltip>,
      },
    ],
  };
};

export const LABEL_CELSIUS = '°C';
export const LABEL_FAHRENHEIT = '°F';

export const adminOperationPaths = [
    '/admin-operations',
    '/update/apply-config',
    '/update/update-firmware',
    '/update/ranch-monitoring',
    '/update/delete-firmware-version'
  ];

export const chargeStatus = {
  0: "Not charging",
  1: "Trickle Charge",
  2: "Pre Charge",
  3: "Fast Charge",
  4: "Taper Charge",
  5: "Reserved",
  6: "Top Off",
  7: "Charge Complete"
};

export const rebootStatus = {
  0: "Bootloader Fail",
  1: "Bootloader Pass",
  2: "App init failed",
  3: "App config failed",
  4: "Normal",
  5: "FW update",
  6: "Sleep mode",
  7: "Watchdog"
};

export const nodeMetaDataLabels = {
  id: 'ID',
  identifier: 'Identifier',
  node_type: 'Node Type',
  imei: 'IMEI',
  iccid: 'ICCID',
  lora_eui: 'Lora EUI',
  bluetooth_device_address: 'BT Device Address',
  manufacture_datetime: 'Mfr Date Time',
  manufacturer: 'Manufacturer',
  manufacturer_location: 'Mfr Location',
  manufacturer_assembly_country: 'Mfr Assembly Country',
  batch_number: 'Batch Number',
  line_number: 'Line Number',
  product_code: 'Product Code',
  station_id: 'Station ID',
  operator_id: 'Operator ID',
  flash_tool_sw_version: 'Flash Tool Software Version',
  farmx_part_number: 'FarmX Part Number',
  modem_model: 'Modem Model',
  modem_fw_ver: 'Modem Firmware Version',
  hw_ver: 'Hardware Version',
  sw_ver: 'Software Version',
};
